import React, { Component } from 'react';
import Scroll from 'react-scroll'; // Imports all Mixins
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import {
    Row, Col, Button
} from 'react-bootstrap';
import cx from 'classnames';
import { useSelector } from 'react-redux';

// History
import history from '../../core/history';

// Actions
import { photosShow } from '../../helpers/photosShow';
import { homebanneruploadDir } from '../../config';

//Image
import icon from '/public/SiteIcons/becomeaHostIcon.svg';
import learnIcon from '/public/SiteIcons/learnIcon.png';

import cs from '../../components/commonStyle.css';
import s from './WhyHostBanner.css';

// Or Access Link,Element,etc as follows
let Link = Scroll.Link;
const WhyHostBanner = (props) => {

    const isAuthenticated = useSelector(state => state.runtime.isAuthenticated)

    const handleClick = () => {
        if (isAuthenticated) {
            history.push('/become-a-owner?mode=new');
        } else {
            history.push('/login?refer=/become-a-owner?mode=new');
        }
    }

    const { data } = props;
    let path = photosShow(homebanneruploadDir);

    return (
        <div className={s.container}>
            <div className={cx(s.Banner, cs.dFlex, s.noflex)} style={{ backgroundImage: `url(${path}${data && data.hostBannerImage1})` }}>
                <Row className={cx(cs.dFlex, s.noflex, s.minWidthBanner)}>
                    <Col lg={6} md={7} sm={12} xs={12}>
                        <div className={s.tip}>{data && data.hostBannerContent2}</div>
                        <h1 className={s.mainText}>
                            {data && data.hostBannerTitle1}
                        </h1>
                        <p className={s.listText}>
                            {data && data.hostBannerContent1}
                        </p>
                        <div className={cx(s.whyHostdoubleButton, cs.spaceBottom4)}>
                            <Button
                                className={cx(s.listButton, cs.btnPrimary)}
                                onClick={handleClick}
                            >
                                <img src={icon} className='imgIconRight' />
                                <span>{data?.buttonLabel} </span>
                            </Button>
                            <Link
                                to="scrollSection"
                                spy={true}
                                smooth={true}
                                offset={1} duration={500}
                                className={cx(cs.btnSecondary, s.whyHostLearMoreBtn)}
                            >
                                <img src={learnIcon} className={cx('imgIconRight', s.learnIconCss)} />
                                <span>{data?.buttonLabel2} </span>
                            </Link>
                        </div>
                    </Col>
                    <Col lg={6} md={5} sm={12} xs={12}>
                        <img src={path + data.hostBannerImage2} className={s.leftImageCss} />
                    </Col>
                </Row>
            </div>
        </div >

    );
}

export default withStyles(cs, s)(WhyHostBanner);
